import styled from 'styled-components';

import ActionButton from 'components/action-button';
import { brandFont } from 'components/layout/brand-font';
import Modal from 'components/modal';
import Picture from 'components/picture';

export const StyledModal = styled(Modal)`
  &[data-reach-dialog-content] {
    width: 90%;
    height: 75vh;
    margin: 5em auto;
    position: relative;
    border-radius: ${Styles.borderRadius};

    > button {
      position: absolute;
      inset-block-start: 0;
      inset-inline-start: 0;
      margin-block-start: 10px;
      margin-block-end: 0;
      margin-inline-start: 10px;
      margin-inline-end: 0;
    }

    ${Styles.desktop} {
      margin: 0;
    }
  }
`;

export const ModalInner = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-flow: column;

  h2 {
    text-align: center;
    margin: 0;
    text-transform: ${Styles.textTransform.headlines};
    font: ${brandFont.headerOne};
    font-size: 2rem;
    line-height: 50px;
  }
`;

export const ModalHead = styled.div`
  width: 100%;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
`;

export const ModalContent = styled.div`
  height: 100%;
  display: flex;
  flex-flow: column;
  align-items: center;
`;

export const ModalPicture = styled(Picture)`
  width: 60%;
  margin-block-start: 4vh;

  ${Styles.desktop} {
    max-width: 15rem;
  }
`;

export const Description = styled.div`
  padding: 1.5em;
  text-align: center;
  font-size: 1.15em;
`;

export const ButtonContainer = styled.div`
  width: 100%;
  margin-block-start: auto;
  padding: 1em;

  ${Styles.desktop} {
    margin-block-start: 0;
  }
`;

export const ViewYourOrderButton = styled(ActionButton)`
  width: 100%;
  margin-block-end: 0.6em;

  ${Styles.desktop} {
    width: 50%;
    margin-block-start: 0;
    margin-block-end: 0.6em;
    margin-inline: auto;
  }
`;

export const LockerCodeContainer = styled.div`
  width: 8rem;
  border-radius: 1rem;
  padding: 1rem;
  background: ${Styles.color.cardBackground};
  text-align: center;

  ${Styles.desktop} {
    margin-block-end: 3rem;
  }
`;

export const LockerCode = styled.div`
  text-transform: ${Styles.textTransform.headlines};
  font: ${brandFont.headerOne};
  font-size: 2rem;
  line-height: 1.75rem;
  padding-block-end: 0.375rem;
`;
